/**
 * Cuándo vuelve una corrección repasada, en palabras: «vuelve mañana» / «vuelve
 * en 3 días» / «vuelve hoy», por días de calendario locales. Lo usan el cierre
 * (lo trabajado en verde) y el repaso con el coach.
 */
export function returnsLabel(nextReviewAt: string | null, now: Date = new Date()): string | null {
  if (!nextReviewAt) return null;
  const next = new Date(nextReviewAt);
  const day = (d: Date): number => Date.UTC(d.getFullYear(), d.getMonth(), d.getDate());
  const days = Math.round((day(next) - day(now)) / 86_400_000);
  if (days <= 0) return 'vuelve hoy';
  if (days === 1) return 'vuelve mañana';
  return `vuelve en ${days} días`;
}

const WEEKDAYS = ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'] as const;

/**
 * El día en que vuelve, corto, para la lista del final del repaso (card #604, la
 * pantalla C que eligió Emmanuel el 22/10): «mañana» o «sáb 24». Con `month`, «sáb
 * 24/10» (el recuadro de arriba). `null` sin fecha (una palabra guardada no se programa).
 */
export function returnsDay(
  nextReviewAt: string | null,
  now: Date = new Date(),
  opts: { month?: boolean } = {},
): string | null {
  if (!nextReviewAt) return null;
  const next = new Date(nextReviewAt);
  const day = (d: Date): number => Date.UTC(d.getFullYear(), d.getMonth(), d.getDate());
  const days = Math.round((day(next) - day(now)) / 86_400_000);
  if (days <= 0) return 'hoy';
  if (days === 1) return 'mañana';
  const date = opts.month ? `${next.getDate()}/${next.getMonth() + 1}` : `${next.getDate()}`;
  return `${WEEKDAYS[next.getDay()]} ${date}`;
}
